



















import { Vue, Component, Emit, Ref } from 'vue-property-decorator'

@Component
export default class ImageModal extends Vue {
  @Emit('close')
  onClose() {
    return
  }

  mounted() {
    this.$emit('mounted')
  }

  @Ref('modalContent') content!: HTMLDivElement
}
